export default __webpack_public_path__ + "static/media/xl_uni.89be1dda.png";